import { Type } from "class-transformer";

export class Notification {
    id!: number;
    message!: string;
    type!: NotificationType;
    metadata!: Metadata;
    read!: boolean;
    @Type(() => Date)
    createdAt!: Date;
    forOrder!: boolean;
    orderId!: string;
}

export class Metadata {
    orderId?: string;
}

export enum NotificationType {
    OrderAssigned = 'order_assigned',
    AccountUpdated = 'account_updated',
    OrderAccepted = 'order_accepted',
    OrderAssignmentCleared = 'order_assignment_cleared',
    OrderDenied = 'order_denied',
    OrderPaid = 'order_paid',
    OrderPushed = 'order_pushed',
    OrderCanceled = 'order_canceled',
    EndOfDay = 'end_of_day',
    ChatMessage = 'chat_message'
}